import { generateGuid } from "@entrilia/shared/utilities/generateGuid";
import { ConditionEqualityType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { ConditionField, DimensionDescriptor } from "../../../../../../../../api/types/svTypes.ts";
import { AreaItemType } from "../../../../../../../../api/types/svTypes.ts";

export function createEmptyConditionItem(meta: DimensionDescriptor): ConditionField {
  return {
    meta: meta,
    areaItemType: AreaItemType.CONDITIONS,
    config: {
      guid: generateGuid(),

      filter: {
        dimensionName: meta.name,
        values: [],
        equalityType: ConditionEqualityType.Equal,
      },
    },
  };
}
